import { render } from "./RoomControlPois.vue?vue&type=template&id=4f4730b6&scoped=true"
import script from "./RoomControlPois.vue?vue&type=script&lang=js"
export * from "./RoomControlPois.vue?vue&type=script&lang=js"

import "./RoomControlPois.vue?vue&type=style&index=0&id=4f4730b6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f4730b6"]])

export default __exports__